import { climaticOutSideSensorId, boiler_water_sensor_id, } from 'console/climatic/constants';
import { isStatementForDhw } from './utils';
import { Z3kSecondRoutes } from 'z3k-settings/routes/type';
export function getClimaticThermometersConfig(z3k_config, thermometers) {
    const shared_thermometers = thermometers.map((thermometer) => {
        if (!thermometer) {
            return null;
        }
        const { id } = thermometer;
        const { thermometer_key } = thermometer;
        if (thermometer_key === Z3kSecondRoutes.analog_temperature_sensors) {
            const heating_circuit = z3k_config.heating_circuits?.find(({ water_temp_sensor, dhw_temp_sensor }) => water_temp_sensor === id || dhw_temp_sensor === id);
            const statement_for_dhw = isStatementForDhw(id, z3k_config, heating_circuit);
            const is_needed_thermometer_id = [
                climaticOutSideSensorId,
                boiler_water_sensor_id,
            ].includes(id);
            const show_sensor = heating_circuit || is_needed_thermometer_id || statement_for_dhw;
            if (!show_sensor) {
                return null;
            }
        }
        return thermometer;
    });
    return shared_thermometers;
}
